module.exports = __webpack_public_path__ + "static/media/flavour_border.6902ea5a.svg";